import React from "react";
import AprovalHistoryTable from "./AprovalHistoryTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const AprovalHistoryIndex = () => (
  <ReportProgramsPage
    TableComponent={AprovalHistoryTable}
    loadingMessage="Loading aproval history..."
  />
);

export default AprovalHistoryIndex;
